export default "__VITE_ASSET__00834df5__"